import { z } from "zod";

import { executionSourceSchema, importLogSchema } from "../import";

import { auditEventBaseSchema } from "./audit-event-base";
import { auditEventTypeSchema } from "./audit-event-type";

const importTimingSchema = z.object({
	overallMs: z.number(),
	importStart: z.coerce.date(),
	importEnd: z.coerce.date(),
});

const auditEventImportedDataSchema = z.object({
	executionSource: executionSourceSchema,
	importTiming: importTimingSchema,
	importLog: importLogSchema,
});

export const auditEventImportFailedSchema = auditEventBaseSchema.extend({
	auditType: z.literal(auditEventTypeSchema.enum.ImportFailed),
	data: auditEventImportedDataSchema,
});

export type AuditEventImportFailed = z.infer<typeof auditEventImportFailedSchema>;
